import React, { useState } from "react";
import toast from "react-hot-toast";
import { updateEnterpriseConfig } from "../business/AdminBusiness";
import { Modal } from "./ui/Modal";

const LIMIT_FIELDS = [
  { key: "maxAppointmentsPerMonth", label: "Agendamentos por mês" },
  { key: "maxClients", label: "Clientes" },
  { key: "maxEmployees", label: "Funcionários" },
  { key: "maxSharedAccounts", label: "Usuários e acessos" },
];

const inputClass = "w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent";
const labelClass = "block text-sm font-medium text-gray-700 mb-1";

export const EnterprisePlanModal = ({ user, onClose, onSaved }) => {
  const [limits, setLimits] = useState({
    maxAppointmentsPerMonth: user?.enterpriseLimits?.maxAppointmentsPerMonth ?? "",
    maxClients: user?.enterpriseLimits?.maxClients ?? "",
    maxEmployees: user?.enterpriseLimits?.maxEmployees ?? "",
    maxSharedAccounts: user?.enterpriseLimits?.maxSharedAccounts ?? "",
  });
  const [pricing, setPricing] = useState({
    monthlyPrice: user?.enterprisePricing?.monthlyPrice ?? "",
    annualPrice: user?.enterprisePricing?.annualPrice ?? "",
    notes: user?.enterprisePricing?.notes ?? "",
  });
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const response = await updateEnterpriseConfig(user._id, { ...limits, ...pricing });
      toast.success("Configuração enterprise salva com sucesso!");
      onSaved(response?.data?.user);
    } catch (error) {
      toast.error(error?.response?.data?.msg || "Erro ao salvar configuração enterprise");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal title={`Configurar Enterprise — ${user?.username}`} isOpen onClose={onClose}>
      <p className="text-xs text-gray-500 mb-4">Deixe um campo em branco para deixá-lo ilimitado.</p>

      <div className="space-y-4">
        {LIMIT_FIELDS.map(({ key, label }) => (
          <div key={key}>
            <label className={labelClass} htmlFor={key}>{label}</label>
            <input
              className={inputClass}
              id={key}
              type="number"
              min="0"
              placeholder="Ilimitado"
              value={limits[key]}
              onChange={(e) => setLimits((prev) => ({ ...prev, [key]: e.target.value }))}
            />
          </div>
        ))}
      </div>

      <div className="border-t border-gray-200 my-4 pt-4 space-y-4">
        <p className="text-sm font-semibold text-gray-700">Valores acordados (referência para a Kiwify)</p>

        <div>
          <label className={labelClass} htmlFor="monthlyPrice">Valor mensal (R$)</label>
          <input
            className={inputClass}
            id="monthlyPrice"
            type="number"
            min="0"
            value={pricing.monthlyPrice}
            onChange={(e) => setPricing((prev) => ({ ...prev, monthlyPrice: e.target.value }))}
          />
        </div>

        <div>
          <label className={labelClass} htmlFor="annualPrice">Valor anual (R$)</label>
          <input
            className={inputClass}
            id="annualPrice"
            type="number"
            min="0"
            value={pricing.annualPrice}
            onChange={(e) => setPricing((prev) => ({ ...prev, annualPrice: e.target.value }))}
          />
        </div>

        <div>
          <label className={labelClass} htmlFor="notes">Observações</label>
          <textarea
            className={inputClass}
            id="notes"
            rows={2}
            value={pricing.notes}
            onChange={(e) => setPricing((prev) => ({ ...prev, notes: e.target.value }))}
          />
        </div>

        <p className="text-xs text-gray-500">
          Esses valores não criam nada na Kiwify automaticamente — use como referência pra criar o produto/oferta manualmente no dashboard da Kiwify.
        </p>
      </div>

      <div className="flex gap-2 pt-2">
        <button
          className="flex-1 rounded-md bg-accent px-4 py-2 text-sm font-medium text-white hover:bg-accent-hover disabled:opacity-60"
          onClick={handleSave}
          disabled={isSaving}
        >
          {isSaving ? "Salvando..." : "Salvar configuração Enterprise"}
        </button>
        <button
          className="flex-1 rounded-md border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
          onClick={onClose}
          disabled={isSaving}
        >
          Cancelar
        </button>
      </div>
    </Modal>
  );
};
